import { css as e, styled as t } from "./styled2.mjs";
import { Box as o } from "@mui/material";
const s = e`
	display: block;
	width: auto;
	will-change: transform;
`, l = e`
	height: 30px;
`, n = e`
	height: 44px;
`, m = e`
	height: 88px;
`, x = e`
	height: 132px;
`, h = t(o)`
	${s}
	> img {
		${({ $size: i }) => i === "xsmall" && l}
		${({ $size: i }) => i === "small" && n}
		${({ $size: i }) => i === "medium" && m}
		${({ $size: i }) => i === "large" && x}
	}
`;
export {
  h as StennLogoWrapper
};
//# sourceMappingURL=styles24.mjs.map
